import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Button} from "primereact/button";
import {addLocale} from "primereact/api";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import { AutoComplete } from 'primereact/autocomplete';
import {Calendar} from "primereact/calendar";
import {Badge} from "primereact/badge";
import axios from "axios";

const ProjectitemListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {id} = useParams();
  const [loading] = useState(false);
  const [items, setItems] = useState([]);
  const [detailsVisibleBySchema, setDetailsVisibleBySchema] = useState({});
  const [projectCurrency, setProjectCurrency] = useState('HUF');
  const [projectItemStatuses, setProjectItemStatuses] = useState([]);
  const [productionStatuses, setProductionStatuses] = useState([]);
  const [projectDeadline, setProjectDeadline] = useState(null);
  
  const [employees, setEmployees] = useState([]);
  const [employeeDisplay, setEmployeeDisplay] = useState('');
  const [employeeSuggestions, setEmployeeSuggestions] = useState([]);
  const [employeeSelected, setEmployeeSelected] = useState(false);
  // const [projectItemStatuses, setProjectItemStatuses] = useState([]);

  const [productionTaskDialogVisible, setProductionTaskDialogVisible] = useState(false);
  const [selectedProductionItem, setSelectedProductionItem] = useState(null);
  const [productionTaskMode, setProductionTaskMode] = useState('employee');
  const [productionTaskForm, setProductionTaskForm] = useState({
    employee: '',
    partner: '',
    quantity: '',
    note: '',
    deadline: null
  });
  const [productionTaskSaving, setProductionTaskSaving] = useState(false);
  const [partners, setPartners] = useState([]);
  const [partnerDisplay, setPartnerDisplay] = useState('');
  const [partnerSuggestions, setPartnerSuggestions] = useState([]);
  const [partnerSelected, setPartnerSelected] = useState(false);

  const getCurrentBacklink = () => {
    const currentHash = window.location.hash || '';
    return currentHash.startsWith('#') ? currentHash.substring(1) : currentHash;
  };

  const isProductionItemEmployeeAssignable = (productionItem) => {
    return productionItem?._meta?.technology?.employee_assignable === true;
    // return true;
  };

  const isProductionSubContractor = (productionItem) => {
    return productionItem?._meta?.technology?.subcontractor === true;
    // return true;
  };

  const formatCellValue = (value, fieldSchema) => {
    if (value === null || value === undefined || value === '') return '';
     if (fieldSchema?.output_format === 'currency') {
      return window.App.currencyFormatter(projectCurrency, value);
    }
      if ( fieldSchema?.type === 'bool') {
      const boolValue = value === true || value === 1;
      return boolValue ? (
        <i className="pi pi-check text-success" title={props.t('yes')}></i>
      ) : (
        <i className="pi pi-times text-danger" title={props.t('no')}></i>
      );
    }
    if (fieldSchema?.type === 'number') {
      const numberValue = Number(value);

      if (!Number.isFinite(numberValue)) {
        return value;
      }
      const fixedNumber = numberValue.toFixed(3).replace(/\.?0+$/, '');
      const [integerPart, decimalPart] = fixedNumber.split('.');
      const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return decimalPart
        ? `${formattedInteger},${decimalPart}`
        : formattedInteger;
    }
    if (fieldSchema?.options?.labelField) {
      return value?.[fieldSchema.options.labelField] || value?.name || value;
    }
    return value?.name || value;
  };

  const renderNoStatusBadge = () => {
    return (
      <Badge
        value="Nincs státusz"
        style={{
          backgroundColor: '#6c757d',
          color: '#ffffff'
        }}
      />
    );
  };

  const getStatusRawValue = (value) => {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    if (typeof value === 'object') {
      return value.id || value.key || value.value || value.name || null;
    }
    return value;
  };

  const isProjectItemStatusField = (field) => {
    const name = (field?.name || '').toLowerCase();
    return [
      'project_item_status',
      'projectitemstatus',
      'project_item_status_id',
      'projectitemstatusid'
    ].includes(name);
  };

  const isProductionStatusField = (field) => {
    const name = (field?.name || '').toLowerCase();
    return [
      'status',
      'production_status',
      'productionstatus',
      'production_status_id',
      'productionstatusid'
    ].includes(name);
  };

  const renderProjectItemStatusBadge = (value) => {
    const rawValue = getStatusRawValue(value);
    if (!rawValue) {
      return renderNoStatusBadge();
    }
    const status = projectItemStatuses.find(item =>
      Number(item.id) === Number(rawValue) ||
      String(item.key) === String(rawValue) ||
      String(item.name) === String(rawValue) ||
      String(item.value) === String(rawValue)
    );
    if (!status) {
      return renderNoStatusBadge();
    }
    return (
      <Badge
        value={status.name || status.value || rawValue}
        style={{
          backgroundColor: status.color || '#6c757d',
          color: '#ffffff'
        }}
      />
    );
  };

  const renderProductionStatusBadge = (value) => {
    const rawValue = getStatusRawValue(value);
    if (!rawValue) {
      return renderNoStatusBadge();
    }
    const status = productionStatuses.find(item =>
      String(item.key) === String(rawValue) ||
      String(item.value) === String(rawValue)
    );
    if (!status) {
      return renderNoStatusBadge();
    }
    return (
      <Badge
        value={status.value || rawValue}
        severity={status.badge || 'secondary'}
      />
    );
  };

  const renderSummaryRow = (schemaItem, fields, actionColumn = true) => {
    const summary = schemaItem?.summary?.projectItem || {};
    const summaryKeys = Object.keys(summary);
    if (!fields?.length || !summaryKeys.length) {
      return null;
    }
    const hasMatchingField = fields.some(field =>
      Object.prototype.hasOwnProperty.call(summary, field.name)
    );
    if (!hasMatchingField) {
      return null;
    }
    return (
      <tr className="project-item-summary-row">
        {fields.map((field, index) => {
          const hasValue = Object.prototype.hasOwnProperty.call(summary, field.name);
          return (
            <td key={field.name || index} className="p-text-left">
              <strong>
                {index === 0
                  ? props.t('total')
                  : hasValue
                    ? formatCellValue(summary[field.name], field)
                    : ''}
              </strong>
            </td>
          );
        })}
        {actionColumn && <td></td>}
      </tr>
    );
  };

  const renderSchemaSummary = (schemaItem) => {
    const projectItemFields = schemaItem?.header?.projectItem?.fields || [];
    const productionItemFields = schemaItem?.header?.productionItems?.fields || [];
    const summary = schemaItem?.summary?.projectItem || {};
    const hasProjectItemSummary = projectItemFields.some(field =>
      Object.prototype.hasOwnProperty.call(summary, field.name)
    );
    if (hasProjectItemSummary) {
      return renderSummaryRow(schemaItem, projectItemFields, true);
    }
    const hasProductionItemSummary = productionItemFields.some(field =>
      Object.prototype.hasOwnProperty.call(summary, field.name)
    );
    if (hasProductionItemSummary) {
      return (
        <tr className="project-item-summary-wrapper-row">
          <td
            colSpan={(projectItemFields.length || 0) + 1}
            className="p-text-center p-py-0 p-px-0"
          >
            <table className="w-100 project-item-summary-table" cellPadding="5px" cellSpacing={0}>
              <tbody>
                {renderSummaryRow(schemaItem, productionItemFields, false)}
              </tbody>
            </table>
          </td>
        </tr>
      );
    }
    return null;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  // const actionBodyTemplate = (rowData) => {
  //   return (
  //     <React.Fragment>
  //       <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-ml-2"
  //               tooltip={props.t('edit')}
  //               type={"button"}
  //               loading={loading}
  //               tooltipOptions={{position: 'left'}}
  //               onClick={() => {

  //               }}/>
  //     </React.Fragment>
  //   );
  // }

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const formatDeadlineValue = (value) => {
    if (!value) return null;
    const date = new Date(value);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hour}:${minute}:00`;
  };

  const getDeadlineValue = (value) => {
    if (!value) return null;
    if (productionTaskForm.deadline) return value;
    const date = new Date(value);
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const emptyDateTimeViewDate = getDeadlineValue(new Date());

  const loadProjectData = (projectId) => {
    if (!projectId) return;
    apiCall('get', '/api/v2/project/' + projectId)
      .then(response => {
        const project = response?.data?.data || {};
        setProjectCurrency(project?.currency || 'HUF');
        setProjectDeadline(project?.deadline || project?.deadline_date || null);
      })
      .catch(() => {
        setProjectCurrency('HUF');
        setProjectDeadline(null);
      });
  };

  const searchEmployee = (event) => {
    const query = (event.query || '').toLowerCase().trim();
    if (!query) {
      setEmployeeSuggestions([]);
      return;
    }
    const filtered = employees
      .filter(employee => {
        const name = (employee.name || '').toLowerCase();
        return name.includes(query);
      })
      .map(employee => ({
        ...employee,
        name: employee.name
      }));
    setEmployeeSuggestions(filtered);
  };

  const closeProductionTaskDialog = () => {
    setProductionTaskDialogVisible(false);
    setSelectedProductionItem(null);
    setProductionTaskMode('employee');
    setProductionTaskForm({
      employee: '',
      partner: "",
      quantity: '',
      deadline: null,
      note: ''
    });
    setPartnerDisplay('');
    setPartnerSuggestions([]);
    setPartnerSelected(false);
    setEmployeeDisplay('');
    setEmployeeSuggestions([]);
    setEmployeeSelected(false);
  };

  const saveProductionTask = () => {
    if (!selectedProductionItem?.id) {
      window.App.toastShow('error', 'Hiba', 'Hiányzik a production item.');
      return;
    }
    const isSubcontractor = productionTaskMode === 'subcontractor';
    if (!isSubcontractor && !productionTaskForm.employee) {
      window.App.toastShow('error', 'Hiba', 'A munkavállaló megadása kötelező.');
      return;
    }
    if (isSubcontractor && !productionTaskForm.partner) {
      window.App.toastShow('error', 'Hiba', 'Az alvállalkozó megadása kötelező.');
      return;
    }
    const payload = {
      production_item: selectedProductionItem.id,
      quantity: Number(productionTaskForm.quantity || 0),
      note: productionTaskForm.note || ''
    };
    if (isSubcontractor) {
      payload.subcontractor = Number(productionTaskForm.partner);
      payload.deadline = productionTaskForm.deadline || null;
    } else {
      payload.employee = Number(productionTaskForm.employee);
    }
    setProductionTaskSaving(true);
    apiCall('post', '/api/v2/production-job', payload)
      .then(() => {
        window.App.toastShow('success', 'Sikeres mentés!');
        closeProductionTaskDialog();
        window.App.setState({
          rerenderProductionjobList: Math.random()
        });
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba', error.toString(), '', error.response);
      })
      .finally(() => {
        setProductionTaskSaving(false);
      });
  };

  const isDetailsVisible = (schemaItem, index) => {
    const key = schemaItem?.schema?.id || index;
    return detailsVisibleBySchema[key] !== false;
  };

  const toggleDetailsVisible = (schemaItem, index) => {
    const key = schemaItem?.schema?.id || index;

    setDetailsVisibleBySchema(prev => ({
      ...prev,
      [key]: prev[key] === false
    }));
  };

  const deleteProjectItem = (projectItemId) => {
    if (!window.confirm('A törlés megerősítésére van szükség!')) {
      return;
    }
    apiCall('delete', '/api/v2/project-item/' + projectItemId)
      .then(() => {
        window.App.toastShow('success', 'Sikeres törlés!');
        window.App.setState({
          rerenderProjectitemList: Math.random()
        });
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba', error.toString(), '', error.response);
      });
  };

  const searchPartner = (event) => {
    const q = (event?.query || '').trim();
    if (q.length < 2) {
      setPartnerSuggestions([]);
      return;
    }
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/partner", {
      params: {
        rows: 15,
        'search[name][operator]': 'like',
        'search[name][value]': `%${q}%`,
        'search[vendor_service][operator]': '==',
        'search[vendor_service][value]': 'true'
      },
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        const items = response?.data?.data?.items || [];
        const mapped = items.map((partner) => ({
          ...partner,
          displayName:
            partner.name +
            (
              partner.address_postal_code || partner.address_city || partner.address_detail
                ? ` (${partner.address_postal_code || ''} ${partner.address_city || ''}, ${partner.address_detail || ''})`
                : ''
            )
        }));
        setPartnerSuggestions(mapped);
      })
      .catch(error => {
        window.App.toastShow('error', props.t('error'), error.toString(), '', error.response);
      });
  };

  useEffect(() => {
    apiCall('get', '/api/v2/project-item-status?' + JSON.stringify({
      first: 0,
      rows: 9999,
      page: 0,
    }))
      .then(response => {
        setProjectItemStatuses(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba', error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/production-status')
      .then(response => {
        setProductionStatuses(response.data?.data || []);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba', error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    const firstProjectItem =
      items?.[0]?.items?.[0]?.projectItem ||
      items?.[0]?.items?.[0]?.project_item ||
      items?.[0]?.items?.[0];

    const projectItemStatusId =
      firstProjectItem?.project_item_status?.id ||
      firstProjectItem?.projectItemStatus?.id ||
      firstProjectItem?.status?.id ||
      firstProjectItem?.project_item_status ||
      firstProjectItem?.projectItemStatus ||
      firstProjectItem?.status;

    const currentProjectItemStatus = projectItemStatuses.find(
      item => Number(item.id) === Number(projectItemStatusId)
    );

    if (currentProjectItemStatus?.color) {
      props?.onStatusColorLoaded?.(currentProjectItemStatus.color);
    }
  }, [items, projectItemStatuses]);

  useEffect(() => {
    apiCall('get', '/api/v2/employee?limit=1000')
      .then(response => {
        const list = response.data?.data?.items || [];
        setEmployees(list);
      })
      .catch(error => {
        window.App.toastShow('error', props.t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    const vars = window.App.urlVars();
    if (vars.employeeName) {
      const decodedName = decodeURIComponent(vars.employeeName);
      setEmployeeDisplay(decodedName);
      setProductionTaskForm(prev => ({
        ...prev,
        employee: vars.employeeId || prev.employee
      }));
    }
  }, [window.App.urlVars().employeeName, window.App.urlVars().employeeId]);

  useEffect(() => {
    const vars = window.App.urlVars();
    if (vars.partnerName) {
      const decodedName = decodeURIComponent(vars.partnerName);
      setPartnerDisplay(decodedName);
      setProductionTaskForm(prev => ({
        ...prev,
        partner: vars.partnerId || prev.partner
      }));
    }
  }, [window.App.urlVars().partnerName, window.App.urlVars().partnerId]);

  useEffect(() => {
    if (window.App.urlVars().projectItemId || id) {
      if (props.view === 'productionProjectItem') {
        apiCall('get', '/api/v2/project-item/' + id + '/schema')
          .then(response => {
            const data = response?.data?.data || [];
            console.log('Project item list data:', response?.data?.data);
            setItems(Array.isArray(data) ? data : [data]);
          })
          .catch(error => {
            window.App.toastShow('error', 'Hiba', error.toString(), '', error.response);
          });
        apiCall('get', '/api/v2/project-item/' + id)
          .then(response => {
            const projectId =
              response?.data?.data?.project?.id ||
              response?.data?.data?.project;
            loadProjectData(projectId);
          })
          .catch(() => {
            setProjectDeadline(null);
          });
      } else {
        apiCall('get', '/api/v2/project/' + id + '/schema')
          .then(response => {
            setItems(response.data.data);
          })
          .catch(error => {
            window.App.toastShow('error', 'Hiba', error.toString(), '', error.response);
          });

        loadProjectData(id);
      }
    }
  }, [id, window.App.state.rerenderProjectShow, window.App.state.rerenderProjectitemList]);

  return (
    <div className={"project-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      {items.map((schemaItem, index) => {
        let _classes = 'p-m-0 p-p-0'
        if(index > 0) {
          _classes = 'p-mb-0 p-p-0 p-mt-3'
        }
        const detailsVisible = isDetailsVisible(schemaItem, index);
        return (
          <>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}>
                <h3 className={" " + _classes}>
                  {schemaItem?.schema?.name || props.t('items')}
                  <Button
                    type="button"
                    icon={detailsVisible ? "pi pi-eye-slash" : "pi pi-eye"}
                    className="item-eye-toggle  p-button-text p-button-sm p-ml-2"
                    tooltip={detailsVisible ? props.t('hideDetails') : props.t('showDetails')}
                    tooltipOptions={{ position: 'right' }}
                    onClick={() => toggleDetailsVisible(schemaItem, index)}
                    style={{
                      width: '1.8rem',
                      height: '1.8rem',
                      verticalAlign: 'middle'
                    }}
                  />
                </h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>

              </div>
            </div>
            <table className={"p-mt-0 w-100"} cellPadding={'5px'} cellSpacing={0}>
              <tr>
                {schemaItem?.header?.projectItem?.fields?.map((field, index) => {
                  return (
                    <th className={"p-text-left"}  style={{ fontWeight: 'normal' }}>
                      {field.label}
                    </th>
                  )
                })}
                <th></th>
              </tr>
              {schemaItem?.items?.map((item, index) => {
                return (
                  <>
                    <tr>
                      {schemaItem?.header?.projectItem?.fields?.map((field, fieldIndex) => {
                        return (
                          <td key={field.name || fieldIndex} className={field.name === 'name' ? 'project-item-name-cell' : ''}>
                            {isProjectItemStatusField(field)
                              ? renderProjectItemStatusBadge(item.projectItem?.[field.name])
                              : formatCellValue(item.projectItem?.[field.name], field)
                            }
                          </td>
                        );
                      })}
                      {props.view !== 'productionProjectItem' && (
                      <td className={"p-text-right"}>
                        {localStorage.getItem('module_manufacturing') &&
                          (localStorage.getItem('roles') || '[]').includes('role_production_project_item_read') &&
                          <Button icon="pi pi-eye" className=" p-button-sm p-ml-2"
                                tooltip={props.t('viewProjectitemProductionDetails')}
                                type={"button"}
                                loading={loading}
                                tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  const backlink = encodeURIComponent(getCurrentBacklink());
                                  history.push(
                                    '/production/project-item/read/' +
                                    item.id +
                                    '?projectItemSchemaId=' +
                                    schemaItem?.schema?.id +
                                    '&projectItemId=' +
                                    item.id +
                                    '&backlink=' +
                                    backlink
                                  );
                                }}/>
                        }
                        <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-ml-2"
                                tooltip={props.t('edit')}
                                type={"button"}
                                loading={loading}
                                tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  history.push('/project/project/read/' + id + '?update=projectItem&projectItemSchemaId=' + schemaItem?.schema?.id + '&projectItemId=' + item.id)
                                }}/>
                        <Button icon="pi pi-trash" className="p-button-sm  p-button-danger p-ml-2"
                                tooltip={props.t('delete')}
                                type={"button"}
                                loading={loading}
                                tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  deleteProjectItem(item.id);
                                }}/>

                      </td>
                      )}
                    </tr>
                    {detailsVisible && item.production_items && item.production_items[0] &&
                      <tr>
                        <td colSpan={(schemaItem?.header?.projectItem?.fields?.length || 0) + 1} className={"p-text-center p-py-0 p-px-0"}>
                          <table className={"w-100"} cellPadding={'1px'} cellSpacing={0}>
                            <tr>
                              {schemaItem?.header?.productionItems?.fields?.map((field, index) => {
                                return (
                                  <th
                                    key={field.name || index}
                                    className={"p-text-left p-pl-1"}
                                    style={{ fontWeight: 'normal' }}
                                  >
                                    {field.label}
                                  </th>
                                )
                              })}
                              {props.view === 'productionProjectItem' && (
                                <th className="p-text-right p-pr-1"></th>
                              )}
                            </tr>
                            {item.production_items
                              .filter(productionItem => productionItem?.id !== null)
                              .map((productionItem, index) => {
                                return (
                                  <tr key={productionItem?.id || index}>
                                    {schemaItem?.header?.productionItems?.fields?.map((field, fIndex) => {
                                      return (
                                        <td
                                          key={fIndex}
                                          className={"p-text-left p-pl-1 " + (fIndex === 0 ? "project-item-name-cell" : "")}
                                        >
                                          {isProductionStatusField(field)
                                            ? renderProductionStatusBadge(productionItem[field.name])
                                            : formatCellValue(productionItem[field.name], field)
                                          }
                                        </td>
                                      )
                                    })}
                                    {props.view === 'productionProjectItem' && (
                                      <td className="p-text-right p-pr-1 p-text-nowrap">
                                        {isProductionItemEmployeeAssignable(productionItem) && (
                                          <Button
                                            type="button"
                                            label={props.t('addProductionTask')}
                                            icon="pi pi-user"
                                            className="p-button-sm p-button-success"
                                            onClick={() => {
                                              setSelectedProductionItem(productionItem);
                                              setProductionTaskMode('employee');
                                              setProductionTaskForm({
                                                employee: '',
                                                partner: '',
                                                quantity: productionItem?.quantity || '',
                                                deadline: null,
                                                note: ''
                                              });
                                              setEmployeeDisplay('');
                                              setEmployeeSuggestions([]);
                                              setEmployeeSelected(false);
                                              setProductionTaskDialogVisible(true);
                                            }}
                                          />
                                        )}
                                        {isProductionSubContractor(productionItem) && (
                                          <Button
                                            type="button"
                                            label={props.t('columnSubcontractor')}
                                            icon="pi pi-briefcase"
                                            className="p-button-sm p-button-success p-ml-2"
                                            onClick={() => {
                                              setSelectedProductionItem(productionItem);
                                              setProductionTaskMode('subcontractor');
                                              setProductionTaskForm({
                                                employee: '',
                                                partner: '',
                                                quantity: productionItem?.quantity || '',
                                                deadline: null,
                                                note: ''
                                              });
                                              setPartnerDisplay('');
                                              setPartnerSuggestions([]);
                                              setPartnerSelected(false);
                                              setProductionTaskDialogVisible(true);
                                            }}
                                          />
                                        )}
                                      </td>
                                    )}
                                  </tr>
                                )
                              })}
                          </table>
                        </td>
                      </tr>
                    }
                    {detailsVisible && item.materials && item.materials[0] &&
                      <tr>
                        <td colSpan={Object.entries(item.projectItem).length + 1} className={"p-text-center p-py-0 p-px-0"}>
                          <table className={"w-100"} cellPadding={'1px'} cellSpacing={0}>
                            <tr>
                              {schemaItem?.header?.materials?.fields?.map((field, index) => {
                                return (
                                  <th className={"p-text-left p-pl-1"} style={{ fontWeight: 'normal' }}>
                                    <small>
                                      {field.label}
                                    </small>
                                  </th>
                                )
                              })}
                            </tr>
                            {item.materials.map((materialItem, index) => {
                              return (
                                <tr key={index}>
                                  {schemaItem?.header?.materials?.fields?.map((field, fIndex) => {
                                    return (
                                      <td key={fIndex} className={"p-text-left p-pl-1"}>
                                        <small>
                                          {formatCellValue(materialItem[field.name], field)}
                                        </small>
                                      </td>
                                    );
                                  })}
                                </tr>
                              )
                            })}
                          </table>
                        </td>
                      </tr>
                    }
                  </>
                )
              })}
              {renderSchemaSummary(schemaItem)}
            </table>
          </>
        )
      })}


      <Dialog
        visible={productionTaskDialogVisible}
        style={{width: '520px'}}
        header={productionTaskMode === 'subcontractor' ? props.t('columnSubcontractor') : props.t('addProductionTask')}
        modal
        onHide={closeProductionTaskDialog}
      >
        <div className="p-fluid">
          {productionTaskMode !== 'subcontractor' && (
          <div className="p-field">
            <label htmlFor="employee">{props.t('employee')}</label>
            <span className="p-inputgroup">
              <Button
                type="button"
                className="p-button"
                onClick={() => {
                  let _params = "?";
                  Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                    if (key !== 'search' && key !== 'employeeId' && key !== 'employeeName') {
                      _params += key + "=" + value + "&";
                    }
                  });
                  _params += "search=employee";
                  history.push(window.location.hash.replace("#", "") + _params);
                }}
              >
                <i className="pi pi-search"></i>
              </Button>

              <AutoComplete
                id="employee"
                value={employeeDisplay}
                suggestions={employeeSuggestions}
                completeMethod={searchEmployee}
                field="name"
                delay={800}
                forceSelection={false}
                // placeholder={props.t('employee')}
                onSelect={(e) => {
                  const picked = e.value;
                  setEmployeeSelected(true);
                  setEmployeeDisplay(picked.name || '');
                  setProductionTaskForm(prev => ({
                    ...prev,
                    employee: picked.id || ''
                  }));
                }}
                onChange={(e) => {
                  if (employeeSelected) {
                    setEmployeeSelected(false);
                    return;
                  }
                  setEmployeeDisplay(e.value);
                  setProductionTaskForm(prev => ({
                    ...prev,
                    employee: ''
                  }));
                }}
                onClear={() => {
                  setEmployeeDisplay('');
                  setProductionTaskForm(prev => ({
                    ...prev,
                    employee: ''
                  }));
                }}
              />
            </span>
          </div>
          )}

          {productionTaskMode === 'subcontractor' && (
            <div className="p-field p-mb-2">
              <label htmlFor="partner">{t('fieldSubcontractor2')}</label>
              <span className="p-inputgroup">
                <Button
                  type="button"
                  className="p-button"
                  onClick={() => {
                    let _params = "?";

                    Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                      if (key !== 'search' && key !== 'partnerId' && key !== 'partnerName') {
                        _params += key + "=" + value + "&";
                      }
                    });

                    _params += "search=partner";
                    _params += "&partnerFilter=vendor_service";

                    history.push(window.location.hash.replace("#", "") + _params);
                  }}
                >
                  <i className="pi pi-search"></i>
                </Button>

                <AutoComplete
                  id="partner"
                  value={partnerDisplay}
                  suggestions={partnerSuggestions}
                  completeMethod={searchPartner}
                  field="displayName"
                  delay={700}
                  forceSelection={false}
                  // placeholder="Alvállalkozó"
                  onSelect={(e) => {
                    const picked = e.value;

                    setPartnerSelected(true);
                    setPartnerDisplay(picked.displayName || picked.name || '');

                    setProductionTaskForm(prev => ({
                      ...prev,
                      partner: picked.id || ''
                    }));
                  }}
                  onChange={(e) => {
                    if (partnerSelected) {
                      setPartnerSelected(false);
                      return;
                    }

                    setPartnerDisplay(e.value);

                    setProductionTaskForm(prev => ({
                      ...prev,
                      partner: ''
                    }));
                  }}
                  onClear={() => {
                    setPartnerDisplay('');

                    setProductionTaskForm(prev => ({
                      ...prev,
                      partner: ''
                    }));
                  }}
                />
              </span>
            </div>
          )}
          {productionTaskMode === 'subcontractor' && (
            <div className="p-field p-mb-2">
              <label htmlFor="deadline">Határidő</label>
              <Calendar
                id="deadline"
                value={productionTaskForm.deadline ? new Date(productionTaskForm.deadline) : null}
                viewDate={!productionTaskForm.deadline ? emptyDateTimeViewDate : null}
                locale="hu"
                dateFormat="yy-mm-dd"
                showIcon
                showTime
                hourFormat="24"
                maxDate={projectDeadline ? new Date(projectDeadline) : null}
                onChange={(e) => {
                  const selectedValue = getDeadlineValue(e.value);
                  setProductionTaskForm(prev => ({
                    ...prev,
                    deadline: formatDeadlineValue(selectedValue)
                  }));
                }}
              />
            </div>
          )}

          <div className="p-field p-mb-2">
            <label htmlFor="quantity">{props.t('quantity')}</label>
            <InputText
              id="quantity"
              type="number"
              value={productionTaskForm.quantity}
              onChange={(e) => {
                setProductionTaskForm({
                  ...productionTaskForm,
                  quantity: e.target.value
                });
              }}
            />
          </div>

          <div className="p-field p-mb-2">
            <label htmlFor="note">{props.t('fieldNote')}</label>
            <InputTextarea
              id="note"
              rows={4}
              value={productionTaskForm.note}
              onChange={(e) => {
                setProductionTaskForm({
                  ...productionTaskForm,
                  note: e.target.value
                });
              }}
            />
          </div>
        </div>

        <div className="p-text-right p-mt-3" style={{ whiteSpace: 'nowrap' }}>
          <Button
            type="button"
            label={props.t('cancel')}
            icon="pi pi-times"
            className="p-button-secondary p-mr-2"
            style={{ width: '120px', display: 'inline-flex' }}
            onClick={closeProductionTaskDialog}
          />

          <Button
            type="button"
            label={props.t('save')}
            icon="pi pi-save"
            className="p-button-success"
            style={{ width: '120px', display: 'inline-flex' }}
            loading={productionTaskSaving}
            disabled={productionTaskSaving}
            onClick={saveProductionTask}
          />
        </div>
      </Dialog>
    </div>
  )
}
export default withTranslation('common')(ProjectitemListComponent);
